import React, { useId } from "react";
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
} from "@coreui/react";
import { DatePicker, Flex, Input, Select, Typography } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useState } from "react";
import {
  addAbonement,
  addOneDayAbonement,
  getAbonementsClient,
  getClubs,
} from "src/store/Slices/ClientsSlice";
import { openNotification } from "src/components/helpers/notification";
import { useEffect } from "react";

const AddAbonement = ({
  abonementModal,
  setAbonementModal,
  clientInfo,
  dayModal,
  setDayModal,
}) => {
  const dateFormatList = ["DD.MM.YYYY"];
  // HELPERS
  const dispatch = useDispatch();

  dayjs.extend(customParseFormat);
  //   const yesterdayDate = dayjs().subtract(1, "day").format("DD.MM.YYYY");

  // STORE
  const abonementsList = useSelector(
    (state) => state.ClientsSlice.abonementsList
  );
  const clubs = useSelector((state) => state.ClientsSlice.clubs);
  // STATE
  const [abonementClubId, setAbonementClubId] = useState(null);
  const [clubId, setClubId] = useState(null);
  // const [oneDay, setOneDay] = useState(false);
  const [daysOfFrezze, setDaysOfFrezze] = useState(0);
  const [from, setFrom] = useState(dayjs());
  const [to, setTo] = useState();
  const [abonementDate, setAbonementDate] = useState();
  const [purchasePrice, setPurchasePrice] = useState(null);
  const [addedFrostDays, setAddedFrostDays] = useState(0);

  const yesNoOptions = [
    { value: true, label: "Да" },
    { value: false, label: "Нет" },
  ];
  // FUNCTIONS
  const onClickAddAbonement = () => {
    if (dayModal) {
      if (!(abonementDate && clubId)) {
        openNotification({ type: "error", message: "Заполните все поля" });
        return;
      }
    }
    dispatch(
      !dayModal
        ? addAbonement({
            clientId: clientInfo.id,
            abonementClubId: abonementClubId,
            from: from
              ? dayjs(from, "DD.MM.YYYY").format("YYYY-MM-DDTHH:mm:ss")
              : null,
            to: to
              ? dayjs(to, "DD.MM.YYYY").format("YYYY-MM-DDTHH:mm:ss")
              : null,
            frostUse: daysOfFrezze ? daysOfFrezze : 0,
            purchasePrice: purchasePrice,
            addedFrostDays: addedFrostDays ? addedFrostDays : 0,
          })
        : addOneDayAbonement({
            userId: clientInfo.id,
            clubId: clubId,
            abonementDate: abonementDate
              ? dayjs(abonementDate, "DD.MM.YYYY").format("YYYY-MM-DDTHH:mm:ss")
              : null,
          })
    ).then(() => {
      dispatch(getAbonementsClient({ clientId: clientInfo.id }));
      setAbonementModal(false);
      setDayModal(false);
    });
  };

  useEffect(() => {
    setAbonementClubId();
    setTo();
    setClubId(null);
    setPurchasePrice(null);
  }, [abonementModal]);

  useEffect(() => {
    setAbonementDate(null);
    dispatch(getClubs());
  }, [dayModal]);

  useEffect(() => {
    setPurchasePrice(
      abonementsList?.data?.value?.find((el) => el.value === abonementClubId)
        ?.abonementPrice
    );
  }, [abonementClubId]);

  return (
    <CModal
      alignment="center"
      visible={abonementModal}
      aria-labelledby="VerticallyCenteredExample"
      onClose={() => {
        setAbonementModal(false);
        // setDayModal(dayModal);
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id="VerticallyCenteredExample">
          {"Добавить абонемент"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <>
            {dayModal ? (
              <>
                <div>
                  <Typography.Title level={5}>Клуб</Typography.Title>
                  <Select
                    style={{ width: "100%" }}
                    options={clubs?.data?.value}
                    onChange={(value) => {
                      setClubId(value);
                    }}
                    placeholder={"Выбрать"}
                    value={clubId}
                  />
                </div>
                <div>
                  <Typography.Title level={5}>Дата</Typography.Title>
                  <DatePicker
                    style={{ width: "100%" }}
                    format={"DD.MM.YYYY"}
                    placement={"topRight"}
                    onChange={(date, dateString) => {
                      setAbonementDate(date);
                    }}
                    value={abonementDate && dayjs(abonementDate)}
                  />
                </div>
              </>
            ) : (
              <>
                <div>
                  <Typography.Title level={5}>Абонемент</Typography.Title>
                  <Select
                    style={{ width: "100%" }}
                    options={abonementsList?.data?.value}
                    onChange={(value) => {
                      setAbonementClubId(value);
                    }}
                    placeholder={"Выбрать"}
                    value={abonementClubId}
                  />
                </div>
                <div>
                  <Typography.Title level={5}>
                    Начало действия абонемента
                  </Typography.Title>
                  <DatePicker
                    style={{ width: "100%" }}
                    format={"DD.MM.YYYY"}
                    placement={"topRight"}
                    onChange={(date, dateString) => {
                      setFrom(date);
                    }}
                    value={from && dayjs(from)}
                  />
                </div>
                <div>
                  <Typography.Title level={5}>
                    Конец действия абонемента
                  </Typography.Title>
                  <DatePicker
                    style={{ width: "100%" }}
                    format={"DD.MM.YYYY"}
                    placement={"topRight"}
                    onChange={(date, dateString) => {
                      setTo(date);
                    }}
                    minDate={
                      from ? dayjs(from).add(1, "day") : dayjs().add(1, "day")
                    }
                    defaultValue={to ? dayjs(to, dateFormatList) : undefined}
                  />
                </div>
                <div>
                  <Typography.Title level={5}>
                    Использовано заморозки, дней
                  </Typography.Title>
                  <Input
                    defaultValue=""
                    type="number"
                    value={daysOfFrezze}
                    onChange={(e) => {
                      setDaysOfFrezze(
                        e.currentTarget.value >= 0 ? e.currentTarget.value : ""
                      );
                    }}
                  />
                </div>
                <div>
                  <Typography.Title level={5}>
                    Добавленных дней заморозки
                  </Typography.Title>
                  <Input
                    defaultValue=""
                    type="number"
                    value={addedFrostDays}
                    onChange={(e) => {
                      setAddedFrostDays(
                        e.currentTarget.value >= 0 ? e.currentTarget.value : ""
                      );
                    }}
                  />
                </div>
                <div>
                  <Typography.Title level={5}>Цена покупки</Typography.Title>
                  <Input
                    defaultValue=""
                    type="number"
                    value={purchasePrice}
                    onChange={(e) => {
                      setPurchasePrice(
                        e.currentTarget.value >= 0 ? e.currentTarget.value : 0
                      );
                    }}
                  />
                </div>
              </>
            )}
          </>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setAbonementModal(false);
            // setDayModal(dayModal);
          }}
          style={{ color: "#fff" }}
          color="secondary"
        >
          Закрыть
        </CButton>
        <CButton onClick={onClickAddAbonement} style={{ color: "#fff" }}>
          Добавить
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default AddAbonement;
